import { CallStatsBucket } from "@/interfaces/CallLog";
import { DateTime } from "luxon";
import { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface Props {
  series: CallStatsBucket[];
}

const BAR_COLOR = "#2c7be5";

interface TooltipEntry {
  value: number;
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string;
}

const CustomTooltip: FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div
      className="bg-white border rounded shadow-sm px-2 py-1 fs--1"
      style={{ minWidth: 140 }}
    >
      <div className="fw-semibold mb-1">{label}</div>
      <div className="d-flex align-items-center justify-content-between gap-2">
        <span className="text-muted">Appels</span>
        <span className="fw-semibold">{payload[0].value}</span>
      </div>
    </div>
  );
};

const CallStatsBarChart: FC<Props> = ({ series }) => {
  if (!series.length) {
    return (
      <div className="text-center text-muted py-5">
        Aucun appel sur la période sélectionnée.
      </div>
    );
  }

  const data = series.map((point) => ({
    bucket: DateTime.fromISO(point.bucket).setLocale("fr").toFormat("dd LLL"),
    count: point.count,
  }));

  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#edf2f9" />
        <XAxis dataKey="bucket" tick={{ fontSize: 12 }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
        <Tooltip
          content={<CustomTooltip />}
          cursor={{ fill: "rgba(44,123,229,0.06)" }}
          wrapperStyle={{ zIndex: 10, outline: "none" }}
          allowEscapeViewBox={{ x: false, y: true }}
        />
        <Bar dataKey="count" name="Appels" fill={BAR_COLOR} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CallStatsBarChart;
